import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';

import { configs } from '@constants/configs/configs';
import { accessibilityActionTypes } from '@constants/actionTypes/accessibilityActionTypes';
import { Dispatch } from 'redux';

interface ISetEnlargedFontEnabled {
    isEnlargedFontEnabled: boolean;
}

export const setEnlargedFontEnabled = ({ isEnlargedFontEnabled }: ISetEnlargedFontEnabled) => ({
    type: accessibilityActionTypes.SET_ENLARGED_FONT_ENABLED,
    isEnlargedFontEnabled,
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchEnlargedFontEnabled = () => async (dispatch: Dispatch) => {
    const url = configs.endpoints.ENLARGED_FONT_ENABLED;
    const data = await API.getData(url, dispatch, actions);
    if (data && data.payload.enlargedFont) {
        dispatch(setEnlargedFontEnabled({ isEnlargedFontEnabled: data.payload.enlargedFont }));
    } else {
        dispatch(setEnlargedFontEnabled({ isEnlargedFontEnabled: false }));
    }
};
